export const home = {
    title: 'Home',

    leftTitle: 'System Information',
    updateInfo: 'Update Information',
    copyMsg: 'Chart copied to your clipboard!',
    labelArrayOverFlowMsg: 'Maximum five labels can be displayed.'
}
